// extracted by mini-css-extract-plugin
export default {"modal":"DepartmentManagerModal-module__modal__n-Win","content":"DepartmentManagerModal-module__content__+Q1WI"};